import {
  ExpenseType,
  IncomeOrExpenseState,
  IncomeOrExpenseType,
  IncomeType,
} from 'further-types/lp/income-and-expenses';
import { CurrencyCode } from 'further-types/lp/vehicle';
import api from 'lib/trpcClient';
import { UseFormSetValue } from 'react-hook-form';
import { FormValues } from '../FormWrapper';

type Props = {
  vehicleId: string | undefined;
};

type SyncSuggestedIncomeOrExpense = {
  suggestedIncomeOrExpense: {
    category: IncomeOrExpenseType;
    incomeOrExpenseType: IncomeType | ExpenseType | string;
    incomeOrExpenseState: IncomeOrExpenseState;
    vatRate: number;
    currencyCode: CurrencyCode;
  } | null;
  setValue: UseFormSetValue<FormValues>;

  counterparty: {
    id?: string;
    name: string;
  };
};

const useSuggestIncomeAndExpense = ({ vehicleId }: Props) => {
  const apiUtils = api.useUtils();

  const fetchSuggestedIncomeOrExpense = async (counterparty: {
    id?: string;
    name: string;
  }) => {
    if (!vehicleId) {
      throw new Error('Vehicle ID is required');
    }

    if (!counterparty?.id) {
      return null;
    }

    const result =
      await apiUtils.incomeAndExpenses.getSuggestedIncomeOrExpenseGroup.fetch({
        counterpartyId: counterparty.id,
        vehicleId,
      });

    return result ?? null;
  };

  const syncSuggestedIncomeOrExpense = ({
    suggestedIncomeOrExpense,
    setValue,
    counterparty,
  }: SyncSuggestedIncomeOrExpense) => {
    const { id: counterpartyId, name: counterpartyName } = counterparty ?? {};
    const hasCounterpartySelected = counterpartyId && counterpartyName;

    if (suggestedIncomeOrExpense && hasCounterpartySelected) {
      setValue('category', suggestedIncomeOrExpense.category);
      setValue(
        'incomeOrExpenseType',
        suggestedIncomeOrExpense.incomeOrExpenseType,
      );
      setValue(
        'incomeOrExpenseState',
        suggestedIncomeOrExpense.incomeOrExpenseState,
      );
      setValue('vatRate', suggestedIncomeOrExpense.vatRate);
      setValue('currencyCode', suggestedIncomeOrExpense.currencyCode);
    }
  };

  return { fetchSuggestedIncomeOrExpense, syncSuggestedIncomeOrExpense };
};

export default useSuggestIncomeAndExpense;
